import { useSearchParams } from 'react-router-dom';
import { resolveVersion } from '@/versions/registry';

// Reads ?v=<id> from the URL and mounts the matching version's root component.
// Each version is a fully self-contained tree (its own chrome, scenes, tokens)
// so opening /?v=1 and /?v=2 in two tabs renders honest side-by-side snapshots.
export function VersionSwitch() {
  const [params] = useSearchParams();
  const version = resolveVersion(params.get('v'));
  const Component = version.Component;
  // `key` forces a full remount when the version changes, so stale chrome /
  // ephemeral state never bleeds across version switches in the same tab.
  return <Component key={version.id} />;
}
